import MUIPaper, { PaperProps } from '@mui/material/Paper';

const Paper = (props: PaperProps) => {
  return <MUIPaper {...props} />;
};

export default Paper;
